<template>
  <div>
    <v-dialog v-model="dialog" max-width="380" persistent content-class="bra-20">
      <v-card>
        <v-card-title class="headline">
          {{ usuario.ativo === "N" ? "Ativar Usuário" : "Desativar Usuário" }}

          <v-spacer />

          <v-btn icon class="mr-n2" @click="$emit('change-dialog', false)">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider />

        <v-card-text class="mt-5">
          <p class="ma-0">
            {{ usuario.ativo === 'S' ? 'Deseja realmente desativar este usuário?' : 'Deseja realmente ativar este usuário?' }}
          </p>
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn color="primary" text @click="ativarOuDesativarUsuario()">
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import UsuarioApi from "@/api/usuario"
import {logout} from "@/helpers";

export default {
  model: {
    prop: "dialog",
    event: "change-dialog",
  },
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    usuario: {
      type: Object,
    },
  },
  emits: ['change-dialog', 'licencas-esgotadas', 'estado-ativacao-usuario-alterado'],
  methods: {
    ativarOuDesativarUsuario() {
      const headers = this.Helpers.iniciarRequisicao()

      const parametros = {
        id: this.usuario.id,
      };

      this.$store.dispatch("loading/addRequisicao",
        UsuarioApi.mudarEstadoAtivacaoUsuario(headers, parametros)
          .then(response => {
            const {token, licencasEsgotadas} = response.data;
            localStorage.setItem("token", token);
            this.$emit('change-dialog', false);

            if (licencasEsgotadas) {
              this.$emit('licencas-esgotadas', {
                ativo: true,
                mensagem: ['Limite de licenças esgotadas, entre em contato com o suporte.']
              })
            }

            this.$emit('estado-ativacao-usuario-alterado', {});
          })
          .catch(logout)
      );
    },
  },
};
</script>
